import React, { useId, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import '../styles/Content.css';

const normalizeCommand = (raw) => {
  const trimmed = (raw || '').trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('/')) return trimmed.toLowerCase();
  return `/${trimmed.toLowerCase()}`;
};

const CommandBar = ({
  placeholder = 'Type /projects, /about, /contact, /resume, /education, or /languages',
  onCommand,
}) => {
  const inputId = useId();
  const [value, setValue] = useState('');
  const [feedback, setFeedback] = useState('');

  const normalized = useMemo(() => normalizeCommand(value), [value]);

  const run = async () => {
    if (!normalized) return;
    try {
      const message = await onCommand(normalized, { surface: 'command_bar', trigger: 'submit' });
      setFeedback(message || '');
      if (!message) setValue('');
    } catch (e) {
      setFeedback('Could not run that command.');
    }
  };

  return (
    <form
      className="cmd"
      onSubmit={(e) => {
        e.preventDefault();
        run();
      }}
    >
      <label className="cmd-label" htmlFor={inputId}>
        Command
      </label>

      <div className="cmd-shell">
        <span className="cmd-icon" aria-hidden="true">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </span>

        <input
          id={inputId}
          className="cmd-input"
          type="text"
          value={value}
          spellCheck={false}
          autoCapitalize="none"
          autoCorrect="off"
          placeholder={placeholder}
          onChange={(e) => setValue(e.target.value)}
        />

        <button className="cmd-open" type="submit">
          OPEN
        </button>
      </div>

      {feedback ? <div className="cmd-feedback">{feedback}</div> : null}
    </form>
  );
};

export default CommandBar;
